import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography } from "@mui/material";
import { useState } from "react";
import { sxSubTitle } from "../../../../../assets/styles/CommonSxProps";
import { StepTermosProps } from "../../../../../interfaces/props/Cancelamento/StepTermosProps";
import { sxButton } from "../sxProps";
import Terms from "../../../../../components/Terms";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import ModalActionResponsive from "../../../../../components/ModalActionResponsive";

const StepTermos: React.FC<StepTermosProps> = ({ backStep, onProceed, cancellationTerms, benefsToCancel, tipoCancelamento }) => {

  const accessibility = useAccessibility();

  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [showModalConfirmation, setShowModalConfirmation] = useState<boolean>(false);
  const [textModal, setTextModal] = useState<string>('');

  const toggleAcceptedTerms = () => {
    setAcceptedTerms(accepted => !accepted);
  }

  const confirmationModal = () => {
    setShowModalConfirmation(true);

    const benefs = benefsToCancel
      .map((benef, index) => {
        const isLast = index === benefsToCancel.length - 1;
        return `<strong>${benef.nome}</strong>${isLast ? '' : ','}`;
      })
      .join('<br />');

    const textAll = `
      Após a confirmação, não será possível desfazer a solicitação. 
      Ao clicar em “SIM, EU QUERO CANCELAR”, o contrato do plano de saúde será cancelado definitivamente para todos os beneficiários, sem possibilidade de uso a partir de amanhã.`;

    const textBenef = `
      Após a confirmação, não será possível desfazer a solicitação. 
      Ao clicar em “SIM, EU QUERO CANCELAR”, o beneficiário abaixo será excluído definitivamente, sem possibilidade de uso do plano de saúde a partir de amanhã.<br /><br />
      Beneficiário(s):${benefsToCancel.length > 1 ? '<br />' : ' '}${benefs}`;

    setTextModal(tipoCancelamento === 'CONTR' ? textAll : textBenef);

    setTextModal(tipoCancelamento === 'CONTR' ? textAll : textBenef);
  };


  return (
    <>
      <div className="motivo-cancelamento-container">
        <Typography component="h1" style={accessibility.textStyleAccessibility} sx={sxSubTitle}>
          Aceite dos termos
        </Typography>
        <Terms toggleCheck={toggleAcceptedTerms} terms={cancellationTerms?.termo} acceptText="Li e aceito os termos acima" />
        <div className='cancellation-buttons-container'>
          <Button
            variant="contained"
            size="large"
            sx={sxButton}
            style={accessibility.buttonStyleAccessibility}
            disabled={!acceptedTerms}
            onClick={confirmationModal}
          >
            <Typography style={accessibility.buttonTextStyleAccessibility}>CONFIRMAR CANCELAMENTO</Typography>
          </Button>
          <button style={{ ...accessibility.textStyleAccessibility }} className="back-button" onClick={backStep} aria-label="Voltar para carta de cancelamento">
            <FontAwesomeIcon style={{ ...accessibility.textStyleAccessibility }} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </div>
      </div>
      <ModalActionResponsive
        showModal={showModalConfirmation}
        textContainedButton="Sim, eu quero cancelar"
        textOutlinedButton="Não, eu não quero cancelar"
        title="Confirmação de cancelamento"
        icon="warning"
        subTitle={textModal}
        handleContainedButton={onProceed}
        handleOutlinedButton={() => setShowModalConfirmation(false)}
        handleShowModal={() => setShowModalConfirmation(false)}
        colorContainedButton="error"
        width="724px"
      />
    </>
  );
}

export default StepTermos;